// e561c71c84520e04e36e4ce9b1e8000a0527df6f|className=QueryResultApi|type=angular|apiName=agent|apiEnumKey=Agent|operationHash=0b2ef0e61dd3dba600f311c8706233b79d125551|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseMetricResultRowsPageFromJSON } from '../../../parsers/MetricResultRowsPage';
import { parseQueryResultApiExportResultParamsToJSON } from '../../../parsers/QueryResultApiExportResultParams';
import { parseQueryResultApiReadRowsParamsToJSON } from '../../../parsers/QueryResultApiReadRowsParams';

export class QueryResultApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags QueryResultApi
   * @name QueryResultApiReadRows
   * @summary Read a page of the rows behind a result handle
   * @request GET:/customers/{customerId}/query-results/{handleId}/rows
   * @secure
   */
  readRows(
    {
      customerId,
      handleId,
      ...query
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/query-results/${handleId}/rows`,
        route: '/customers/{customerId}/query-results/{handleId}/rows',
        method: 'GET',
        query: parseQueryResultApiReadRowsParamsToJSON(query),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseMetricResultRowsPageFromJSON,
    isContentArray: false,
  }),
      },
    );
  }

  /**
   * @description <p>🔐 Auth</p><p>🛡 CustomerAuth</p><p>🛡 ChatAccessAuth</p>
   *
   * @tags QueryResultApi
   * @name QueryResultApiExportResult
   * @summary Export the complete result behind a handle as a file
   * @request POST:/customers/{customerId}/query-results/{handleId}/export
   * @secure
   */
  exportResult(
    {
      customerId,
      handleId,
      ...query
    },
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/customers/${customerId}/query-results/${handleId}/export`,
        route: '/customers/{customerId}/query-results/{handleId}/export',
        method: 'POST',
        query: parseQueryResultApiExportResultParamsToJSON(query),
        api: Api.Agent,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    isContentArray: false,
  }),
      },
    );
  }

  static ɵfac = function QueryResultApi_Factory(t) { return new (t || QueryResultApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: QueryResultApi, factory: QueryResultApi.ɵfac, providedIn: 'root' });
}
